import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable, } from 'rxjs';
import { environment } from 'environments/environment';
import { Prospecto } from '../models/prospecto';
import { Planes } from '../models/planes';
import { MasterPdf } from '../models/masterPdf';

const BACKEND_URL = environment.apiUrl;


@Injectable({
  providedIn: 'root'
})
export class CotizacionService {

  constructor(private http: HttpClient) { }

  GenerarPDF(prospecto: Prospecto, planes: Planes, valoresGarantizados: any, a1: number, a2: string, formato: string, edadRetiro: string): Observable<any> {

    let objPdf: MasterPdf = {
      planes: planes,
      prospecto: prospecto,
      valoresGarantizados: valoresGarantizados
    };

    const params = new HttpParams().set('a1', a1.toString()).set('a2', a2).set('pdf', formato).set('edadRetiro', edadRetiro);
    return this.http.post(BACKEND_URL + '/pdf/', objPdf, {
      params: params,
      responseType: "blob",
      headers: new HttpHeaders().append("Content-Type", "application/json")
    });
  }

  obtenerComboLayout(): Observable<any> {
    return this.http.get(BACKEND_URL + '/cotLayouts');
  }


} 
